import {
  AUTODIAL_OPS_LOAD,
  AUTODIAL_OPS_LOADING,
  AUTODIAL_OPS_ERROR,
  AUTODIAL_OPS_SET_AGENT,
  AUTODIAL_OPS_TOGGLE_LIVE,
} from '../actions/autoDialOps';

const defaultState = {
  agentType:        'doctor',  // 'doctor' | 'tele_caller'
  live:             true,      // when false, polling pauses (manual refresh only)
  loading:          false,
  error:            null,
  lastUpdatedAt:    null,

  // Server payload (matches getMisDataV2 shape)
  kpis:             {},
  poolUtilization:  { onCall: 0, alignedAndActive: 0, utilizationPct: 0 },
  hourlyTrend:      [],
  failureBreakdown: [],
  oldestPending:    [],
  pending:          [],
  inFlight:         [],
  exhausted:        [],
  connected:        [],
  agentPerformance: [],
};

export default function autoDialOps(state = defaultState, action) {
  switch (action.type) {
    case AUTODIAL_OPS_LOADING:
      return { ...state, loading: true, error: null };

    case AUTODIAL_OPS_LOAD: {
      const p = action.payload || {};
      return {
        ...state,
        loading:          false,
        error:            null,
        lastUpdatedAt:    Date.now(),
        agentType:        p.agentType || state.agentType,
        kpis:             p.kpis || {},
        poolUtilization:  p.poolUtilization || defaultState.poolUtilization,
        hourlyTrend:      p.hourlyTrend || [],
        failureBreakdown: p.failureBreakdown || [],
        oldestPending:    p.oldestPending || [],
        pending:          p.pending || [],
        inFlight:         p.inFlight || [],
        exhausted:        p.exhausted || [],
        connected:        p.connected || [],
        agentPerformance: p.agentPerformance || [],
      };
    }

    case AUTODIAL_OPS_SET_AGENT:
      return { ...state, agentType: action.payload };

    case AUTODIAL_OPS_TOGGLE_LIVE:
      return { ...state, live: !state.live };

    case AUTODIAL_OPS_ERROR:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
